import { SmartSearchModel } from "src/app/core/smartsearch/smartsearch";
import { ViewMode } from "../constants/enum.pos";
import { PagingResponse } from "./pagination";

export interface MenuGroupItem {
	id: number;
	name: string;
}

export interface MenuGroup {
	id: number;
	name: string;
	nameEn: string;
	nameVi: string;
	nameCn: string;
	parentGroupId: string;
	categoryId: string;
	parentGroupName: string;
	parentGroupNameEn: string; // Support for view column parent group name
	parentGroupNameVi: string; // Support for view column parent group name
	parentGroupNameCn: string; // Support for view column parent group name
	categoryName: string;
	categoryNameEn: string; // Support for view column category name
	categoryNameVi: string; // Support for view column category name
	categoryNameCn: string; // Support for view column category name
	isVisible: boolean;
	sortOrder: number;
	btnColor: string;
	textColor: string;
}

export interface GroupDataView {
	group: MenuGroup;
	viewMode: ViewMode;
	menuGroups?: MenuGroup[];
}

export interface MenuGroupResponse extends PagingResponse {
	data: MenuGroup[];
}

export interface CategoryGroup {
	id: number;
	name: string;
}

export class MenuGroupSearchRequest extends SmartSearchModel {
	menuCategoryId: number = null;
}


export class MenuGroupSortOrderRequest {
	menuCategoryId: number = null;
	data: MenuGroupSortOrderDetailRequest[] = [];
}

export interface MenuGroupSortOrderDetailRequest {
	id: number;
	sortOrder: number;
}
